import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import * as ExtraIntegrations from '@sentry/integrations';

Sentry.init({
  dsn: environment.sentry.browserDsn,
  tracesSampleRate: environment.sentry.browserSampleRate,
  environment: environment.tag,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new ExtraIntegrations.ExtraErrorData({ depth: 9 })
  ],
  normalizeDepth: 10
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => {
  console.error(err);
  Sentry.captureException(err);
});
